import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setConfigurator } from '../../actions'
import ListItem from './ListItem'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator
})

const mapDispatchToProps = { setWizards, setConfigurator }

export default connect(mapStateToProps, mapDispatchToProps)(ListItem)
